import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccessItems } from "ui/Scripts/source/models/common/saveSuccessItems";
import { postApiCall } from "./tokenService";

// #region Edit Attachment
export const recordEditRemoveAttachments = (obj: any): Promise<ApiSuccess> => {
    return postApiCall<ApiSuccess>("api/record/editremoveattachments", ApiSuccess, JSON.stringify(obj));
};

export const recordEditAddAttachments = (obj: any): Promise<SaveSuccessItems> => {
    return postApiCall<SaveSuccessItems>("api/record/editaddattachments", SaveSuccessItems, JSON.stringify(obj));
};
// #endregion Edit Attachment